export default __webpack_public_path__ + "static/media/Artboard 24.ebcd3f0a.png";